import { bgBlur } from 'src/theme/css';

import { useTheme } from '@mui/material/styles';
import { Link , AppBar , Toolbar } from '@mui/material';

import { useOffSetTop } from 'src/hooks/use-off-set-top';

import Logo from 'src/components/logo';

import { HEADER } from '../config-layout';
import HeaderShadow from './header-shadow';

// ----------------------------------------------------------------------

export default function HeaderSimple() {
  const theme = useTheme();

  const offsetTop = useOffSetTop(HEADER.H_DESKTOP);

  return (
    <AppBar>
      <Toolbar
        sx={{
          justifyContent: 'space-between',
          height: {
            xs: HEADER.H_MOBILE,
            md: HEADER.H_DESKTOP,
          },
          transition: theme.transitions.create(['height'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter,
          }),
          ...(offsetTop && {
            ...bgBlur({
              color: theme.palette.background.default,
            }),
            height: {
              md: HEADER.H_DESKTOP_OFFSET,
            },
          }),
        }}
      >
        <Logo />

        <Link
          href="mailto:supporto@heyjob.it"
          component="a"
          color="inherit"
          sx={{ typography: 'subtitle2' }}
        >
          Hai bisogno di aiuto?
        </Link>
      </Toolbar>

      {offsetTop && <HeaderShadow />}
    </AppBar>
  );
}
